import {
  useEffect 
} from "react";

interface UseGTMOptions {
    id: string;
    dataLayerName?: string;
}

export const useGTM = ({
  id, dataLayerName = "dataLayer" 
}: UseGTMOptions): void => {
  useEffect(() => {
    // Google Tag Manager initialization
    (function (w: any, d: Document, s: string, l: string, i: string) {
      w[l] = w[l] || [];
      w[l].push({
        "gtm.start": new Date().getTime(),
        event: "gtm.js",
      });
      const f = d.getElementsByTagName(s)[0];
      const j = d.createElement(s) as HTMLScriptElement;
      const dl = l !== "dataLayer" ? "&l=" + l : "";

      j.async = true;
      j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
      f.parentNode?.insertBefore(j, f);
    })(window, document, "script", dataLayerName, id);
  }, [id, dataLayerName]);
};
